import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const NAV = [
  { label: "首页", to: "/" },
  { label: "现场实拍", to: "/category/scene" },
  { label: "事件合集", to: "/category/collection" },
  { label: "路人视角", to: "/category/bystander" },
  { label: "对话录音", to: "/category/dialogue" },
  { label: "关于我们", to: "/about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [kw, setKw] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = kw.trim();
    setOpen(false);
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : "/category");
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-background-200/70 bg-background-50/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="吃瓜视频在线 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-vidicon-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
            吃瓜视频<span className="text-primary-500">在线</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition hover:bg-background-200/60 hover:text-foreground-950"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submit} className="hidden items-center md:flex" role="search">
          <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 py-1.5 pl-4 pr-1.5 transition focus-within:border-primary-500">
            <i className="ri-search-line text-sm text-foreground-600"></i>
            <input
              type="text"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜索事件关键词"
              className="w-36 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 lg:w-48"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1 text-xs font-semibold text-background-50 transition hover:bg-primary-600"
            >
              搜索
            </button>
          </div>
        </form>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 backdrop-blur-xl lg:hidden">
          <nav className="mx-auto max-w-[1280px] px-4 py-3 md:px-6" aria-label="移动端导航">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition hover:bg-background-200/60 hover:text-foreground-950"
              >
                {item.label}
              </Link>
            ))}
            <form onSubmit={submit} className="mt-3 flex items-center gap-2 px-1 pb-1" role="search">
              <input
                type="text"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                placeholder="搜索事件关键词"
                className="flex-1 rounded-full border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-500 focus:border-primary-500"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
              >
                搜索
              </button>
            </form>
          </nav>
        </div>
      )}
    </header>
  );
}